import { render, staticRenderFns } from "./ComingSoonPopup.vue?vue&type=template&id=4b1a7444&scoped=true"
import script from "./ComingSoonPopup.vue?vue&type=script&lang=js"
export * from "./ComingSoonPopup.vue?vue&type=script&lang=js"
import style0 from "./ComingSoonPopup.vue?vue&type=style&index=0&id=4b1a7444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a7444",
  null
  
)

export default component.exports